import type { ErrorPayload } from "@mk/shared";
import { activeErrors, activeMessages } from "@mk/active-catalog";
import type { Messages } from "./messages.tr.ts";

export const errors = activeErrors;
export const messages: Messages = activeMessages;

export function errorMessage(payload: Pick<ErrorPayload, "error"> & { params?: unknown }): string {
  const formatter = (errors as Record<string, (params?: unknown) => string>)[payload.error];
  if (!formatter) return errors.generic();
  try {
    return formatter(payload.params);
  } catch {
    return errors.generic();
  }
}

export function unknownErrorMessage(payload: unknown): string {
  if (!payload || typeof payload !== "object") return errors.generic();
  const body = payload as { error?: unknown; params?: unknown };
  if (typeof body.error !== "string") return errors.generic();
  return errorMessage(body as Pick<ErrorPayload, "error"> & { params?: unknown });
}
